import { FanGroupOwnerFanGroupEntity } from '@seaters/constants';
import { create } from 'zustand';

interface FanGroupState {
  fanGroup: FanGroupOwnerFanGroupEntity | undefined;
  // false while the audience is still loading; true once one is set or the user has none
  isFanGroupResolved: boolean;
  setFanGroup: (fanGroup: FanGroupOwnerFanGroupEntity | undefined) => void;
  setNoFanGroup: () => void;
}

export const useFanGroupStore = create<FanGroupState>((set) => ({
  fanGroup: undefined,
  isFanGroupResolved: false,
  setFanGroup: (fanGroup: FanGroupOwnerFanGroupEntity | undefined) =>
    set(() => ({ fanGroup: fanGroup, isFanGroupResolved: !!fanGroup })),
  setNoFanGroup: () =>
    set(() => ({ fanGroup: undefined, isFanGroupResolved: true })),
}));
